import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { getProcess } from '../../service/service';
import { CustomizedDataGrid } from '../customized_data_grid';
import type { Column } from 'react-data-grid';
import '../processes/processes.css';
import Loader from '../Loader/loader';

export default function ProcessesListing() {
	interface Row {
		id: string;
		name: string;
		description: string;
	}
	const [sortingInfo, setSortingInfo] = useState({ sortBy: '', sortDir: '' });
	function getColumns(): Array<Column<Row>> {
		return [
			{
				key: 'name',
				name: 'Process',
				minWidth: 308
				// editor: textEditor
			},
			{
				key: 'description',
				name: 'Description',
				minWidth: 400
			},
			{
				key: 'impact',
				name: 'Impact',
				minWidth: 250
			}
		];
	}
	// Default view option in three dots
	const defaultColumnNames = ['Process', 'Description', 'Impact'];

	const [processList, setProcessList] = useState<any[]>([]);
	const [paginationData, setPaginationData] = useState({ totalElements: 0, totalPages: 0 });
	const [page, setPage] = useState(1);
	const [pageSize, setPageSize] = useState(100);

	const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
		processListingFunc(value, pageSize, sortingInfo);
	};

	const handlepageSizeChange = (event: any) => {
		processListingFunc(page, event.target.value, sortingInfo);
	};

	useEffect(() => {
		processListingFunc(page, pageSize, sortingInfo);
	}, []);

	async function processListingFunc(pageNumber: any, size: any, sortingInfo: any) {
		const res = await getProcess(pageNumber.toString(), size.toString(), sortingInfo);
		if (res.success) {
			setProcessList(res.data.process);
			setPaginationData(res.data.page);
			setPage(pageNumber);
			setPageSize(size);
			setSortingInfo(sortingInfo);
		}
	}
	const handleSorting = (sortingInfo: any) => {
		processListingFunc(page, pageSize, sortingInfo);
	};

	return (
		<div className="page-table processes_tabledata">
			<Grid>
				{processList.length > 0 ? (
					<CustomizedDataGrid
						tableColumns={getColumns()}
						tableData={processList}
						tableType="Process"
						defaultColumnNames={defaultColumnNames}
						onSorting={handleSorting}
						currSorting={sortingInfo}
						page={page}
						pageSize={pageSize}
						paginationData={paginationData}
						listLength={processList.length}
						handlepageSizeChange={handlepageSizeChange}
						handlePageChange={handlePageChange}
						isDateRangeFilter={false}
						isDisabled={false}
					/>
				) : (
					<Loader />
				)}
			</Grid>
		</div>
	);
}
